<template>
  <div class="footerBottom">
    <!-- <div v-if="paramsIndex != 'internationalFair'" :class="paramsIndex == 'index' ? 'image-div-index' : (paramsIndex == 'register' ? 'image-div-register' : 'image-div')">
       <a :href="bannerLink"
           target="_blank">
          <img
            :src="bannerurl"
            style="width: 1200px;height: auto;text-align: center;margin: 0 auto;"
          />
      </a>
     </div> -->
    <div class="footer_top">
      <div class="footer_content">
        <div class="footer_content_title">
          <span class="footer_content_title_en">PARTNERS</span>
          <span class="footer_content_title_ch" v-if="lan == 'ch'">我们的合作伙伴</span>
          <img src="../../assets/img/04.png">
        </div>

        <div class="footer_content_top">
          <!-- style="width: 50%" -->
          <a
            href="http://www.forwardersmart.com/tools/cardDirectoryList.html"
            target="_blank"
          >
            <div class="footer_content_top_wrap">
              <div class="footer_content_top_wrap_left">
                <div class="content_ref">
                  <div class="content_icon">
                    <img src="../../assets/guest.png" alt />
                  </div>
                  <div class="content_ref_text" style="margin-left: 10px;">
                    <div>{{ language.makeCard }}</div>
                    <div style="margin-top: 5px">{{ language.extend }}</div>
                  </div>
                </div>
              </div>
              <div class="footer_content_top_wrap_right">
                <div class="content_text">{{ language.card }}</div>
                <!-- <div style="width: 35px;background:#0088c7;height: 3px;margin: 10px 0"></div> -->
              </div>
            </div>
          </a>
          <div style="width: 285px">
            <a :href="linkCangnaer" target="_blank">
              <div class="footer_content_top_wrap_2">
                <div class="footer_content_top_wrap_left_2">
                  <div class="content_ref">
                    <img
                      src="../../assets/clound_icon.png"
                      style="width: 157px;height: auto;margin-top:6px;"
                    />
                  </div>
                </div>
                <div class="footer_content_top_wrap_right_2">
                  <div class="content_text">{{ language.cloud }}</div>
                  <!-- <div style="width: 35px;background:#0088c7;height: 3px;margin: 10px 0"></div> -->
                </div>
              </div>
            </a>
          </div>
          <!--底部展会-->
          <div>
            <a :href="yunzhanLink" target="_blank">
              <div class="footer_content_top_wrap_5">
                <div class="footer_content_top_wrap_left_5">
                  <img
                      src="../../assets/logonew_bottom.png"
                      alt
                      style="width:200px;height: auto;border: 0px;"
                  />
                </div>
                <div class="footer_content_top_wrap_right_5">
                  <div class="content_text">{{ language.business1 }}</div>
<!--                  <div class="content_ref_text" style="margin-top: 5px">-->
<!--                    {{ language.platform }}-->
<!--                  </div>-->
                </div>
              </div>
            </a>
          </div>

        </div>
        <div class="footer_content_top">
          <div>
            <!-- <div class="content_text">{{language.vip}}</div>
            <div style="width: 35px;background:#0088c7;height: 3px;margin: 10px 0"></div> -->
            <a :href="wanfaLink" target="_blank">
              <div class="footer_content_top_wrap_3">
                <div class="footer_content_top_wrap_left_3">
                  <div>
                    <img
                      src="../../assets/wiffa-logo.png"
                      style="width: 110px;height: auto"
                    />
                  </div>
                </div>
                <div class="footer_content_top_wrap_right_3">
                  <div class="content_ref_text">
                    <div class="content_text">{{ language.vip }}</div>
                    <div style="margin-top: 0px">
                      {{ language.know1 }}
                    </div>
                  </div>
                </div>
              </div>
            </a>
          </div>
          <div>
            <a href="service.html">
              <div class="footer_content_top_wrap_4">
                <div class="footer_content_top_wrap_left_4">
                  <img
                    :src="logoUrl"
                    alt
                    style="width:149px;height: auto;border: 0px;"
                  />
                </div>
                <div class="footer_content_top_wrap_right_4">
                  <div class="content_text">{{ language.business2 }}</div>
                  <div class="content_ref_text" style="margin-top: 5px">
                    {{ language.platform1 }}
                  </div>
                </div>
              </div>

              <!-- <div class="content_ref">
                <div style="margin-top: 5px">
                  <img
                   :src="logoUrl"
                    alt
                    style="width:200px;height: auto;border: 0px;"
                  />

                  <div class="content_ref_text" style="margin-top: 5px">{{language.platform}}</div>
                </div>
              </div> -->
            </a>
          </div>
        </div>
        <!--白色界面-->
        <!--        <div class="footer_content_bottom">-->
        <!--          <div class="footer_bottom_image" style="height: 160px;position: absolute;left: 0">-->
        <!--            <img src="../../assets/footer_icon.png" style="height: 160px"/>-->
        <!--          </div>-->
        <!--          <div class="image_text">{{language.offlineEvent}}</div>-->
        <!--          <div class="footer_content_centre">-->
        <!--            <div style="color: #125caf;font-size: 28px">{{language.internationalization}}</div>-->
        <!--            <div style="font-size: 17px;color: #125caf;margin-top: 5px">World International Freight Forwarder Alliance Convention(WIFFAC)</div>-->
        <!--            <div style="color: #444444;font-size: 14px;margin-top: 5px">-->
        <!--              <span>{{language.time}}：{{language.startTime}}</span>-->
        <!--              <span style="margin-left: 45px">{{language.local}}：{{language.localPlace}}</span>-->
        <!--            </div>-->
        <!--            <div style="color: #444444;font-size: 14px;margin-top: 5px">{{language.sponsor}}：{{language.localPlace}}</div>-->
        <!--            <div></div>-->
        <!--          </div>-->
        <!--          <div class="footer_code">-->
        <!--            <img src="../../assets/qr_image.png" style="width: 107px;height: 107px">-->
        <!--            <div style="color: #4c4c4c;font-size: 12px;text-align: center">{{language.scanQR}}</div>-->
        <!--          </div>-->
        <!--        </div>-->
        <!-- <a :href="bannerLink"
           target="_blank">
          <img
            :src="bannerurl"
            style="width: 1200px;height: auto;position: absolute;bottom: 0;left: 50%;transform: translateX(-50%)"
          />
        </a> -->

         <!--我要做广告--->
      <div class="inside-adlocation-box" v-if="footerAdShow">
              <a  href="javascript:;" v-if="lan=='ch'">
                <div class="inside-adlocation">
                  <img  :src="footerOtherADList" alt="" />
<!--                   <img  :src="adFooterLinkImg" alt="" />-->
              </div>
            </a>
            <a  href="javascript:;"  v-else >
                <div class="inside-adlocation">
                  <img  :src="footerOtherADList" alt="" />
              </div>
            </a>
       </div>

      </div>

    </div>
    <div class="footer_bottom">
      <div class="footer_bottom_content">
        <!--<div class="bottom_text" style="margin-left: 10px">
          <div>
            <a
              :title="language.aboutUs"
              target="_blank"
              href="http://www.shippingchina.com/about/index/index.html">
              {{language.aboutUs}}
              <span style="margin: 0 5px">|</span>
            </a>

            <a
              :title="language.blueBusiness"
              target="_blank"
              href="http://www.shippingchina.com/about/pagead/index.html">
              {{language.blueBusiness}}
              <span style="margin: 0 5px">|</span>
            </a>

            <a
              :title="language.forwarderConference"
              target="_blank"
              href="http://www.wiffa.net/meeting2020/pre">{{language.forwarderConference}}
              <span style="margin: 0 5px">|</span>
            </a>

            <a
              :title="language.GlobalShippingSummit"
              target="_blank"
              href="http://gss2013.shippingchina.com/">
              {{language.GlobalShippingSummit}}
              <span style="margin: 0 5px">|</span>
            </a>


            <a
              :title="language.InternationalFreightFair"
              target="_blank"
              href="http://www.wiffa.net/meeting2020/pre">{{language.InternationalFreightFair}}
              <span style="margin: 0 5px">|</span>
            </a>

            <a
              href="javascript:void(0);"
              @click="setHomepage(this,'http://www.shippingchina.com/')"
              target="_self"
              :title="language.setToHomePage">{{language.setToHomePage}}
            </a>
          </div>
          <div style="margin-top: 5px">
            © {{language.allRightsReserved}} 2020 WIFFA SHIPPINGTECH CO.,LTD. All Rights Reserved
          </div>
        </div>-->
        <div class="footer_btn">
          <div class="exh_btn_left">
            <a href="about.html" style="color: #85d3ff;">
<!--              <img v-if="lan=='ch'" src="../../assets/index_bottom_logo.png" alt="" />-->
<!--              <img v-else src="../../assets/index_bottom_logo_en.png" alt="" />-->
<!--              &lt;!&ndash; {{language.aboutExh}} &ndash;&gt;-->
            <img  src="../../assets/img/12.png" alt="" />
            </a>
              <!-- {{language.aboutExh}} -->
          </div>
          <!-- <div class="exh_btn_left" style="margin-left: 10px">
            <a href="service.html" style="color: #85d3ff">{{language.exhTel}}</a>
          </div> -->
        </div>
        <a href="about.html" style="color: #d0d8e7">
        <div class="bottom_text" style="margin-left: 40px;height: 67px;">
          <div>{{ language.AboutDirecruit }}</div>
          <div style="margin-top: 5px">About Us</div>
        </div>
        </a>
        <div class="bottom_text" style="margin-left: 40px;height: 67px;">
          <div>{{ language.customerPhone }}</div>
          <div style="margin-top: 5px">86-411-82817405</div>
        </div>
        <div class="bottom_text" style="margin-left: 60px">
          <span>{{ language.license }}：辽B2-20140067</span>
          <span style="margin-left: 0px"
            ><a href="https://beian.miit.gov.cn/" target="_blank" style="color: #d0d8e7">{{ language.internetRecord1 }}：辽B-2-4-20080120-8</a></span
          >
          <div style="margin-top: 5px">
<!--            ©-->
             {{ language.allRightsReserved }}
            {{ new Date().getFullYear() }} WIFFA SHIPPINGTECH CO.,LTD. All
            Rights Reserved
          </div>
          <div style="margin-top: 5px">
            <a target="_blank" href="https://jobxcx.wiffa-edu.com/human_resource_certificate.jpg" style="color:#d0d8e7">
              {{ language.humanResources }}：210201211381号
            </a>
          </div>
        </div>

        <div class="IMGcontent beian">
          <a
            class="beian3"
            target="_blank"
            href="http://ln.cyberpolice.cn/alertPawsAction.do?method=LOUT&amp;&amp;id=dl"
            >安安</a
          >
          <a
            class="beian2"
            target="_blank"
            href="javascript:void(0)"
            style="cursor:text"
            >网警</a
          >
          <a
            class="beian1"
            target="_blank"
            href="https://exhxcx.shippingchina.com/Public/uploads/2020-06-13/ICP2019-2024.jpg"
            >工商</a
          >
          <a class="beian4" href="javascript:void(0);">文网文</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cook from "../../common/cookie";
import {getExhibitorsLogoList} from "@/api/forum";
export default {
  props: {
    language: {
      type: Object,
      default: () => {},
    },
    paramsIndex: {
      type: String,
    },
  },
  data() {
    return {
      lan: Cook.get("lang"),
      // logoUrl: require("@/assets/logonew_bottom.png"),
      logoUrl: require("@/assets/img/bottom-logo.png"),
      bannerurl: require("../../assets/banner.jpg"),
      linkCangnaer: "http://www.forwardersmart.com/",
      yunzhanLink:"https://www.wiffa-exh.com/",
      wanfaLink: "http://www.wiffa.net/",
      bannerLink: "http://www.wiffa.net/meeting2020/pre/index.html",
      footerOtherADList:'',
      footerAdShow:false
      // adFooterLinkImg: require('../../assets/otherAd.jpg'),
      // adFooterLinkImgen: require('../../assets/otherAd.jpg'),

    };
  },
  mounted() {
    this.getOtherfooterAd();
    let lan = Cook.get("lang");
    if (lan == "ch") {
    } else {
      //  this.logoUrl = require('@/assets/logo_en.png');
      this.logoUrl = require("@/assets/logonew_bottom_en.png");
      this.bannerurl = require("../../assets/banner_en.jpg");
      this.linkCangnaer = "http://en.forwardersmart.com/";
      //  this.linkCangnaer = 'http://www.forwardersmart.com/enindex/aboutus.html';
      this.wanfaLink = "http://www.wiffa.net/en/index/index.html";
      this.bannerLink = "http://www.wiffa.net/meeting2020/pren/index.html";
    }
  },
  methods: {
    setHomepage(obj, vrl) {
      try {
        obj.style.behavior = "url(#default#homepage)";
        obj.setHomePage(vrl);
      } catch (e) {
        if (window.netscape) {
          try {
            netscape.security.PrivilegeManager.enablePrivilege(
              "UniversalXPConnect"
            );
          } catch (e) {
            alert(
              "此操作被浏览器拒绝！\n请在浏览器地址栏输入“about:config”并回车\n然后将 [signed.applets.codebase_principal_support]的值设置为'true',双击即可。"
            );
          }
          var prefs = Components.classes[
            "@mozilla.org/preferences-service;1"
          ].getService(Components.interfaces.nsIPrefBranch);
          prefs.setCharPref("browser.startup.homepage", vrl);
        } else {
          alert(
            "您的浏览器不支持，请按照下面步骤操作：1.打开浏览器设置。2.点击设置网页。3.输入：" +
              vrl +
              "点击确定。"
          );
        }
      }
    },

    getOtherfooterAd(){
        //获取底部其他链接广告图片
       getExhibitorsLogoList({exhibition_id:'', platform_type:(this.lan == "ch"?0:1), ad_id:14, ad_type:0}).then(
        (res) => {
          if(res.data[0].file_path!=''){
            this.footerOtherADList = res.data[0].file_path;
            this.footerAdShow=true;
          }
        }
      );
    }
  },
};
</script>

<style scoped>
.footerBottom img {
  border: 0px;
}
.footerBottom {
  min-width: 1200px;
  width: 100%;
}
.image-div {
  height: 160px;
  margin-bottom: 20px;
  /* margin: 0 auto; */
  text-align: center;
}
.image-div-index {
  height: 160px;
  text-align: center;
  padding-bottom: 20px;
  background: #e6f3fc;
}
.image-div-register {
  height: 160px;
  text-align: center;
  padding-bottom: 20px;
  background: #f2f2f2;
}
.footer_top {
  /* height: 140px; */
  padding: 50px 0;
  background: #0172fe;
  position: relative;
  overflow: hidden;
  margin-top:5px;
}
.footer_content {
  width: 1200px;
  margin: auto;
}
.footer_content_title {
  color: #fff;
  margin-left: 30px;
  margin-bottom: 70px;
  text-align: left;
}
.footer_content_title_en {
  font-size: 30px;
  text-align: left;
}
.footer_content_title_ch {
  font-size: 20px;
  margin-left: 20px;
  text-align: left;
}
.footer_content_title img {
  position: relative;
  right: 4px;
  top: -10px;
}
.footer_bottom {
  /* height: 113px; */
  background: #0052b7;
}
.footer_bottom_content {
  width: 1200px;
  margin: auto;
  display: flex;
  display: -webkit-box;
  align-items: center;
  height: 100%;
  padding: 30px 0;
}
.content_text {
  color: #ffffff;
  font-size: 18px;
  text-align: left;
}
.footer_content_top {
  display: flex;
  display: -webkit-box;
  /* margin-left: 30px; */
  margin: 40px 0 40px 30px;
}
.footer_content_top_wrap {
  display: flex;
  width: 400px;
}
.footer_content_top_wrap_left {
  flex: 1;
  padding-right: 20px;
  border-right: 1px solid #bcd8f4;
}
.footer_content_top_wrap_right {
  flex: 1;
  padding-left: 20px;
  line-height: 45px;
}

.footer_content_top_wrap_2 {
  display: flex;
  width: 400px;
}
.footer_content_top_wrap_left_2 {
  flex: 1;
  padding-right: 20px;
  border-right: 1px solid #bcd8f4;
}
.footer_content_top_wrap_right_2 {
  flex: 2;
  padding-left: 20px;
  line-height: 45px;
}
.footer_content_top_wrap_5 {
  display: flex;
  width: 400px;
  margin-left: 90px;
}
.footer_content_top_wrap_left_5 {
  flex: 1;
  padding-right: 20px;
  border-right: 1px solid #bcd8f4;
}
.footer_content_top_wrap_right_5 {
  flex: 2;
  padding-left: 20px;
  line-height: 45px;
}
.footer_content_top_wrap_3 {
  display: flex;
  width: 400px;
}
.footer_content_top_wrap_left_3 {
  flex: 1;
  padding-right: 20px;
  border-right: 1px solid #bcd8f4;
}
.footer_content_top_wrap_right_3 {
  flex: 2;
  padding-left: 20px;
}

.footer_content_top_wrap_4 {
  display: flex;
  width: 500px;
}
.footer_content_top_wrap_left_4 {
  flex: 1;
  padding-right: 20px;
  border-right: 1px solid #bcd8f4;
}
.footer_content_top_wrap_right_4 {
  flex: 2;
  padding-left: 20px;
}
.footerBottom .footer_content_bottom {
  background: #ffffff;
  width: 1200px;
  height: 160px;
  margin-top: 45px;
  position: relative;
}
.footer_content_centre {
  position: absolute;
  top: 22px;
  left: 250px;
}
.footer_code {
  position: absolute;
  top: 18px;
  right: 116px;
}
.image_text {
  position: absolute;
  color: #268fa7;
  font-size: 26px;
  z-index: 1000;
  top: 22px;
  left: 30px;
}
.footer_btn {
  display: flex;
  display: -webkit-flex;
  align-items: center;
  height: 67px;
}
.content_ref {
  display: flex;
  /* display: -webkit-box; */
  align-items: center;
}
.content_icon {
  width: 45px;
  height: 45px;
  font-size: 20px;
  line-height: 45px;
  text-align: center;
  color: #ffffff;
  padding-right: 10px;
}
.content_ref_text {
  color: #ffffff;
  font-size: 14px;
  text-align: left;
}
.bottom_text {
  color: #d0d8e7;
  font-size: 14px;
  text-align: left;
}

.bottom_text a {
  color: #a9bbcf;
  font-size: 14px;
}
.footerBottom .IMGcontent {
  text-align: center;
  margin-bottom: 18px;
  width: 260px;
  height: 45px;
  padding: 5px 0;
}
.footerBottom .Text3 a {
  color: #fcfcfc;
}
a {
  text-decoration: none;
}
.content_text a {
  color: #ffffff;
}
a.beian1,
a.beian2,
a.beian3 {
  float: right;
  overflow: hidden;
  display: block;
  width: 55px;
  height: 55px;
  text-align: left;
  background: url(../../assets/HYmiddleItem14.png) no-repeat 0 0;
  text-indent: -1000px;
}
a.beian3 {
  background-position: -90px 0;
}
a.beian2 {
  background-position: -45px 0;
  width: 45px;
}
a.beian4 {
  float: right;
  overflow: hidden;
  display: block;
  width: 50px;
  height: 50px;
  text-align: left;
  background: url(../../assets/wenhuajingying.png) no-repeat 0 0;
  background-size: 100% 100%;
  text-indent: -1000px;
  margin-top: 5px;
  margin-right: 15px;
}
.exh_btn_left {
  width: 160px;
  height: 47px;
  font-size: 18px;
  color: #85d3ff;
  text-align: center;
  border-right: 1px solid #79a3d9;
  cursor: pointer;
  position: relative;
  top: -8px;

}
.exh_btn_left img {
  width: 111px;
}

.inside-adlocation-box{
  margin-top:20px;
  border-radius:10px;
}

.inside-adlocation-box a{
  height:170px;
  width:100%;
  display:block;
}

.inside-adlocation{
  width:100%;
  height:170px;
}

.inside-adlocation img{
  width:100%;
  height:100%;
  border-radius:10px;
}
</style>
